<template>
  <div>
    <ld-header
      @click-left="back"
      v-show="sourceTag!='fuyi'"
    >
      支付成功
    </ld-header>
    <div class="pad-6">
      <van-cell class="b-r-4">
        <van-row>
          <van-col span="17">
            <div class="font24 font-lg pad-6">
              <span v-if="sourceTag == 'fuyi'">支付确认中</span>
              <span v-else>支付成功</span>
            </div>
            <p class="font12 pad-6">
              <span class="font14" v-if="sourceTag == 'fuyi'">如您已成功支付，请返回差旅平台查看订单信息</span>
              <span v-else>点击'查看订单'可查看此订单详情</span>
            </p>
            <div class="pad-6 half-width" v-show="sourceTag!='fuyi'">
              <ld-button
                size="md"
                defaults
                round
                @click="toDetail"
              >
                {{ $t('B011','查看订单') }}
              </ld-button>
            </div>
          </van-col>
          <van-col span="7">
            <img
              class="full-width"
              src="~Assets/images/pay/paySuccess.png"
            >
          </van-col>
        </van-row>
      </van-cell>
      <div class="pad-b-5" />
      <ld-button
        detault
        to="/home"
        v-show="sourceTag!='fuyi'"
      >
        {{ $t('B012','继续预订') }}
      </ld-button>
    </div>
  </div>
</template>

<script>
import {Cell} from 'vant'
import ldButton from 'Common/ldButton'
import Bussiness from 'Utils/business'

export default {
  name:'PaySuccess',
  components: {
    [Cell.name]:Cell,
    ldButton
  },
  data(){
    return {
      orderList:[]
    }
  },
  computed:{
    orderType(){
      return this.$route.query.orderType
    },
    orderId(){
      return this.$route.query.orderId
    },
    out_trade_no(){
      return this.$route.query.out_trade_no
    },
    sourceTag(){
      return this.$route.query.tag
    },
  },
  created(){
  },
  mounted(){
    if(this.out_trade_no){
      this.showOrderDetail(this.out_trade_no)
    }
  },
  methods:{
    toDetail(){
      if(this.orderList.length>0){
        var order = this.orderList[0]
        Bussiness.toOrderDetail({id:order.orderId,orderType:order.orderType})
      }else{
        Bussiness.toOrderDetail({id:this.orderId,orderType:this.orderType})
      }
    },
    showOrderDetail(payInfoId){
      this.$api['common/getPayOrderIdList']({
        payInfoId:payInfoId
      }).then(resp=>{
        this.orderList=resp.data||[]
      })
    },
    back(){
      this.$router.push({path:'/allOrder?findType=1'})
    }
  },
  filters:{
  }
}
</script>

<style  lang="less" scoped>
.pad-6{
    padding: 6px;
}
.pad-b-5{
    padding-bottom: 5px;
}
.b-r-4{
    border-radius: 4px;
}
.half-width{
    width: 50%;
}
</style>
